import { BrowserModule, DomSanitizer, HammerModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Injectable, NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatIconRegistry } from '@angular/material/icon';

import { ReactiveFormsModule } from '@angular/forms';

import { AuthTokenInterceptor } from 'routes/interceptor';
import { JFlexLayoutModule } from 'modules/flex-layout/flex-layout.module';
import { NgxWebstorageModule } from 'ngx-webstorage';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { ConfirmationDialogModule } from 'dialogs/confirmation';
import { CountdownDialogModule } from 'dialogs/countdown';
import { LoginBoxDialogModule } from 'dialogs/loginbox';
import { MessageBoxDialogModule } from 'dialogs/messagebox';
import { SettingsDialogModule } from 'dialogs/settings';
import { SplashDialogModule } from 'dialogs/splash';

// Application Modules
import { RoleTextPipeModule } from 'pipes/roletext';
import { TitleCasePipeModule } from 'modules/pipes';

import { AppComponent } from './components/app/app.component';
import { AppRoutingModule } from 'routes/app.routing-module';
import { AuthenticatedGuard, UnsavedChangesGuard, UnsavedChangesService } from 'routes/routes.guard';

// UI Components
import { UserInfoComponent } from './components/userinfo/userinfo.component';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
    events = ['doubleTap'];
    // overrides = {
    //     swipe: { direction: Hammer.DIRECTION_ALL },
    //     tap: { event: 'doubleTap', taps: 2 },
    //     // tslint:disable-next-line: no-any
    // } as any;
}

@NgModule({
    declarations: [
        AppComponent,

        // UI components
        UserInfoComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HammerModule,
        HttpClientModule,
        JFlexLayoutModule,
        AppRoutingModule,
        NgxWebstorageModule.forRoot(),
        ReactiveFormsModule,

        MatButtonModule,
        MatIconModule,

        ConfirmationDialogModule,
        CountdownDialogModule,
        LoginBoxDialogModule,
        MessageBoxDialogModule,
        SettingsDialogModule,
        SplashDialogModule,

        // Application module imports
        RoleTextPipeModule,
        TitleCasePipeModule,
    ],
    providers: [
        AuthenticatedGuard,
        UnsavedChangesGuard,
        UnsavedChangesService,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthTokenInterceptor,
            multi: true,
        },
        DatePipe,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {
        this.iconRegistry.addSvgIcon('custompdf', this.sanitizer.bypassSecurityTrustResourceUrl('file-pdf-box.svg'));
        this.iconRegistry.addSvgIcon('customexcel', this.sanitizer.bypassSecurityTrustResourceUrl('file-excel.svg'));
    }
}
